import { create } from "@bufbuild/protobuf";
import { TimestampSchema, type Timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Convert a protobuf Timestamp to a JavaScript Date
 */
export function timestampToDate(timestamp: Timestamp | undefined): Date | undefined {
  if (!timestamp) return undefined;
  return new Date(Number(timestamp.seconds) * 1000 + timestamp.nanos / 1000000);
}

/**
 * Convert a protobuf Timestamp to an ISO string
 */
export function timestampToString(timestamp: Timestamp | undefined): string | undefined {
  const date = timestampToDate(timestamp);
  return date?.toISOString();
}

/**
 * Convert a JavaScript Date to a protobuf Timestamp
 */
export function toTimestamp(date: Date): Timestamp {
  return create(TimestampSchema, {
    seconds: BigInt(Math.floor(date.getTime() / 1000)),
    nanos: (date.getMilliseconds() % 1000) * 1_000_000,
  });
}

/**
 * Convert a protobuf Timestamp to a formatted date string
 */
export function formatTimestamp(timestamp: Timestamp | undefined, format: 'date' | 'datetime' | 'time' = 'datetime'): string {
  const date = timestampToDate(timestamp);
  if (!date) return '';

  if (format === 'date') {
    return date.toLocaleDateString();
  } else if (format === 'time') {
    return date.toLocaleTimeString();
  }
  return date.toLocaleString();
}
